export const queryKeys = {
  me: () => ['users', 'me'] as const,

  deals: {
    all:    (params?: Record<string, unknown>) => ['deals', params] as const,
    detail: (dealId: string) => ['deals', dealId] as const,
    triage: (dealId: string) => ['deals', dealId, 'triage'] as const,
  },

  notifications: {
    unreadCount: () => ['notifications', 'unread-count'] as const,
  },

  connectors: {
    all:    () => ['admin', 'connectors'] as const,
    detail: (id: string) => ['admin', 'connectors', id] as const,
    health: (id: string) => ['admin', 'connectors', id, 'health'] as const,
  },

  skills: {
    all:    () => ['admin', 'skills'] as const,
    detail: (id: string) => ['admin', 'skills', id] as const,
  },

  jobs: {
    all:     () => ['admin', 'jobs'] as const,
    detail:  (id: string) => ['admin', 'jobs', id] as const,
    history: (id: string) => ['admin', 'jobs', id, 'history'] as const,
  },

  distributionLists: {
    all:    () => ['admin', 'distribution-lists'] as const,
    detail: (id: string) => ['admin', 'distribution-lists', id] as const,
  },

  emailMonitor: {
    config:       () => ['admin', 'email-monitor', 'config'] as const,
    logs:         (params?: Record<string, unknown>) => ['admin', 'email-monitor', 'logs', params] as const,
    subscription: () => ['admin', 'email-monitor', 'subscription'] as const,
  },

  auditLog: {
    all: (params?: Record<string, unknown>) => ['admin', 'audit-log', params] as const,
  },

  reports: {
    all:    () => ['reports'] as const,
    detail: (id: string) => ['reports', id] as const,
  },

  preferences: () => ['users', 'preferences'] as const,

  productTour: {
    active:   () => ['product-tour', 'active'] as const,
    sections: () => ['admin', 'product-tour', 'sections'] as const,
  },
} as const
